import React, { useCallback, useEffect, useState } from 'react';
import HamburgerIcon from '../icons/hamburger.svg?react';
import EnrollmentsIcon from '../icons/profile-enrollments.svg?react';
import InfoIcon from '../icons/profile-info.svg?react';
import BillingIcon from '../icons/profile-billing.svg?react';
import SignOutIcon from '../icons/sign-out.svg?react';
import {
  MessageSquare as CustomerServiceIcon,
  Globe as LanguageIcon,
  X as CloseIcon,
} from 'lucide-react';
import { useApp, api } from '../helpers/api-helpers';
import cn from 'classnames';
import styles from './ProfileMenu.module.css';
import { NavLink, useLocation } from 'react-router-dom';
import Clarity from '@microsoft/clarity';

export function ProfileMenu({ className }) {
  const { user } = useApp();
  const [open, setOpen] = useState(false);
  const [hasTranslatedCourses, setHasTranslatedCourses] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    api.users
      .getEnrollmentTranslations({ id: user.id })
      .then((data) => {
        const enrollments = data?.enrollments || [];
        const hasTranslations = enrollments.some(
          (e) => e.course?.translationLanguages?.length > 0,
        );
        setHasTranslatedCourses(hasTranslations);
      })
      .catch(() => {});
  }, [user?.id]);

  const toggle = useCallback(() => {
    setOpen((open) => !open);
  }, []);

  const close = useCallback(() => {
    setOpen(false);
  }, []);

  function handleCustomerServiceClick() {
    Clarity.setTag('customer-service', 'clicked');
  }

  // Close the menu if we navigate somewhere
  const location = useLocation();
  useEffect(() => {
    close();
  }, [location?.key, close]);

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={styles.content}>
        <button data-testid="app-menu" onClick={toggle}>
          <span>{user?.firstName}</span>
          <HamburgerIcon />
        </button>
        {open && (
          <nav>
            <ul>
              <li onClick={close}>
                <span>{user?.firstName}</span>
                <CloseIcon />
              </li>
              <li>
                <NavLink to="/profile/enrollments">
                  <span>Enrollments</span>
                  <EnrollmentsIcon />
                </NavLink>
              </li>
              <li>
                <NavLink to="/profile/info">
                  <span>Info</span>
                  <InfoIcon />
                </NavLink>
              </li>
              <li>
                <NavLink to="/profile/billing">
                  <span>Billing</span>
                  <BillingIcon />
                </NavLink>
              </li>
              {hasTranslatedCourses && (
                <li>
                  <NavLink to="/profile/language">
                    <span>Language</span>
                    <LanguageIcon />
                  </NavLink>
                </li>
              )}
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://recademics.com/customer-support/"
                  onClick={handleCustomerServiceClick}
                >
                  <span>Customer Service</span>
                  <CustomerServiceIcon />
                </a>
              </li>
              <li>
                <NavLink to="/logout">
                  <span>Sign Out</span>
                  <SignOutIcon />
                </NavLink>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
}
